import {
  ChatIcon,
  CogIcon,
  DesktopComputerIcon,
  HandIcon,
  PhoneIcon,
  UsersIcon
} from "@heroicons/react/outline";
import { MicrophoneIcon, VideoCameraIcon } from "@heroicons/react/solid";

function Controls(props) {
  const cameraMuted = props.cameraMuted;
  const micMuted = props.micMuted;
  const screenShared = props.screenShared;
  const handRaised = props.handRaise;
  const chatVisible = props.chatVisible;
  const onlineUsersVisible = props.onlineUsersVisible;
  const settingsVisible = props.settingsVisible;

  const disableAudio = props.disableAudio;
  const disableVideo = props.disableVideo;
  const disableScreenSharing = props.disableScreenSharing;
  const meetingAccessRequests = props.meetingAccessRequests;
  const disabledChat = props.disabledChat;

  const handleCameraButtonClicked = props.handleCameraButtonClicked;
  const handleMicButtonClicked = props.handleMicButtonClicked;
  const handleScreenShareButtonClicked = props.handleScreenShareButtonClicked;
  const handleHandRaisedButtonClicked = props.handleHandRaisedButtonClicked;
  const handleChatButtonClicked = props.handleChatButtonClicked;
  const handleOnlineUsersButtonClicked = props.handleOnlineUsersButtonClicked;
  const handleEndCallButtonClicked = props.handleEndCallButtonClicked;
  const handleSettingsButtonClicked = props.handleSettingsButtonClicked;

  return (
    <div className=" absolute flex items-center justify-center bottom-4 sm:bottom-24 opacity-95 inset-x-0">
      <div className="bg-slate-900 flex rounded-md shadow-lg">
        {disableVideo ? (
          ""
        ) : cameraMuted ? (
          <button
            onClick={handleCameraButtonClicked}
            className="bg-red-700 hover:bg-red-600 px-4 py-2 sm:px-8 sm:py-2 hover:rounded-l-md rounded-l-md"
          >
            <VideoCameraIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleCameraButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 hover:rounded-l-md"
          >
            <VideoCameraIcon className="w-6 text-white" />
          </button>
        )}

        {disableAudio ? (
          ""
        ) : micMuted ? (
          <button
            onClick={handleMicButtonClicked}
            className="bg-red-700 hover:bg-red-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <MicrophoneIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleMicButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <MicrophoneIcon className="w-6 text-white" />
          </button>
        )}

        {disableScreenSharing ? (
          ""
        ) : screenShared ? (
          <button
            onClick={handleScreenShareButtonClicked}
            className="bg-green-700 hover:bg-green-600 px-4 py-2 hidden sm:block sm:px-8 sm:py-2 "
          >
            <DesktopComputerIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleScreenShareButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 hidden sm:block sm:px-8 sm:py-2 "
          >
            <DesktopComputerIcon className="w-6 text-white" />
          </button>
        )}

        {settingsVisible ? (
          <button
            onClick={handleSettingsButtonClicked}
            className="bg-green-700 hover:bg-green-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <CogIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleSettingsButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <CogIcon className="w-6 text-white" />
          </button>
        )}

        {/* {handRaised ? (
          <button
            onClick={handleHandRaisedButtonClicked}
            className="bg-green-600 hover:bg-green-700 px-4 py-2 hidden sm:block sm:px-8 sm:py-2 "
          >
            <HandIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleHandRaisedButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 hidden sm:block sm:px-8 sm:py-2 "
          >
            <HandIcon className="w-6 text-white" />
          </button>
        )} */}

        {disabledChat ? (
          ""
        ) : chatVisible ? (
          <button
            onClick={handleChatButtonClicked}
            className="bg-green-700  hover:bg-green-600 hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <ChatIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleChatButtonClicked}
            className="hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <ChatIcon className="w-6 text-white" />
          </button>
        )}

        {onlineUsersVisible ? (
          <button
            onClick={handleOnlineUsersButtonClicked}
            className="bg-green-700  hover:bg-green-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            <UsersIcon className="w-6 text-white" />
          </button>
        ) : (
          <button
            onClick={handleOnlineUsersButtonClicked}
            className="relative hover:bg-slate-600 px-4 py-2 sm:px-8 sm:py-2 "
          >
            {meetingAccessRequests && meetingAccessRequests.length > 0 ? (
              <div className="absolute -top-2 right-0 bg-red-600 rounded-full text-white text-xs px-2 py-1">
                {meetingAccessRequests.length}
              </div>
            ) : (
              ""
            )}

            <UsersIcon className="w-6 text-white" />
          </button>
        )}

        <button
          onClick={handleEndCallButtonClicked}
          className="bg-red-700 rounded-r-md hover:bg-red-600 px-4 py-2 sm:px-8 sm:py-2 hover:rounded-r-md"
        >
          <PhoneIcon className="w-6 text-white rotate-90" />
        </button>
      </div>
    </div>
  );
}

export default Controls;
